import React from "react";
import UsersAdmin from "../components/UserAdmin";

const History = () =>{
    return (
        <div>
           <UsersAdmin/>
        </div>
    )
}
export default History;